import React              from 'react';
import styled             from 'styled-components';
import { TTextAlignProp } from '@typings/components';
import { Breakpoint }     from '@material-ui/core/styles/createBreakpoints';
import {
  Dialog            as MuiDialog,
  DialogActions     as MuiDialogActions,
  DialogContent     as MuiDialogContent,
  DialogContentText as MuiDialogContentText,
  DialogTitle       as MuiDialogTitle,
}                         from '@material-ui/core';

export enum MODAL_TYPE {
  default = 'default',
  info    = 'info',
  warn    = 'warn',
}

interface IModal{
  open            : boolean;
  type?           : MODAL_TYPE;
  title?          : string;
  content         : any;
  actions         : JSX.Element | null;
  onClose?        : () => void;
  padding?        : string;
  maxWidth?       : Breakpoint;
  maxwidth?       : string;
  minWidth?       : string;
  fontSize?       : string;
  fontWeight?     : string;
  textColor?      : string;
  textAlign?      : TTextAlignProp;
  titleWeight?    : number;
  justifyContent? : string;
  width?          : string;
}

const Dialog = styled(MuiDialog)`
  [class*='MuiPaper'] {
    width         : ${({ width }: any): false | string => width || '500px'};
    min-width     : ${({ minWidth }: any): false | string => minWidth};
    padding       : 0;
    border-radius : 5px;

    ${({ maxwidth }: any): false | string => maxwidth && `max-width: ${maxwidth}`};
  }
` as any;

const DialogTitle = styled(MuiDialogTitle)`
  && {
    font-size : 20px;
    padding   : 20px 30px;

    h2 {
      font-weight : ${({ titleWeight }: any): string => titleWeight || 300};
      color       : ${({ type, theme: { textColor } }: any): string =>
    (type && type !== MODAL_TYPE.default ? textColor.white : textColor.black)};
    }

    ${({ type, theme: { backgroundColor } }: any): false | string =>
    type === MODAL_TYPE.info && `background-color: ${backgroundColor.darkBlue}`};

    ${({ type, theme: { backgroundColor } }: any): false | string =>
    type === MODAL_TYPE.warn && `background-color: ${backgroundColor.red}`};
  }
` as any;

const DialogContent = styled(MuiDialogContent)`
  && {
    padding: ${({ padding }: any): string => (padding || '15px 30px')} !important;
  }
` as any;

const DialogContentText = styled(MuiDialogContentText)`
  && {
    font-weight : ${({ fontWeight }: any): string => fontWeight ?? '300'};;
    font-size   : ${({ fontSize }: any): string => fontSize ?? '16px'};
    ${({ theme: { textColor }, textColor: color }: any): false | string => textColor && `color: ${textColor[color]}`};
    ${({ textAlign }: any): false | string => textAlign && `text-align: ${textAlign}`};
  }
` as any;

const DialogActions = styled(MuiDialogActions)`
  && {
    padding         : 20px;
    justify-content : ${({ justifyContent, theme: { width } }: any): string => ((width === 'xs') ? 'center' : justifyContent)};
  }
` as any;

export const ModalDialog = ({
  open,
  type,
  title,
  content,
  actions,
  onClose,
  padding,
  maxWidth,
  maxwidth,
  minWidth,
  fontWeight,
  fontSize,
  textColor,
  textAlign,
  titleWeight,
  justifyContent = 'flex-end',
  width,
}: IModal): JSX.Element => (
  <Dialog
    open      = {open}
    onClose   = {onClose}
    maxWidth  = {maxWidth}
    maxwidth  = {maxwidth}
    minWidth  = {minWidth}
    width     = {width}
  >
    {title && (
      <DialogTitle type={type} titleWeight={titleWeight}>
        {title}
      </DialogTitle>
    )}

    <DialogContent padding={padding}>
      <DialogContentText
        fontSize   = {fontSize}
        fontWeight = {fontWeight}
        textColor  = {textColor}
        textAlign  = {textAlign}
      >
        {content}
      </DialogContentText>
    </DialogContent>

    {actions && (
      <DialogActions justifyContent={justifyContent}>
        {actions}
      </DialogActions>
    )}
  </Dialog>
);

ModalDialog.defaultProps = {
  type : MODAL_TYPE.default,
  open : false,
};
